import React, { FC } from 'react';

import { ProductModel } from 'src/components/Cart/models';
import { CartItemList } from 'src/components/CartLineItem/CartItem/CartItemList';
import { componentKeyV2 } from 'src/utils/ComponentKeyV2';

export interface CartListProps {
  product?: ProductModel;
  removeProductById?: (productId: string) => void;
}

interface CartItemProps {
  cartList?: CartListProps[];
}

export const CartItem: FC<CartItemProps> = ({ cartList }) => {
  if (!cartList) return null;

  return (
    <>
      {cartList.map((item, index) => <CartItemList cartListItem={item} key={componentKeyV2(item, index)} />)}
    </>
  );
};

CartItem.displayName = 'CartItem';
